<div class="templates-container">
  <div class="page-section-header">
    <div *ngIf="!isLoading" class="page-section-buttons">
      <a (click)="doCreate()" (keypress)="doCreate()"
        class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon">
        <svg-icon icon="plus" alt="plus"></svg-icon>
        <span translate>Create New Template</span>
      </a>
    </div>
    <h2>Templates</h2>
  </div>

  <!-- Templates List -->
  <div class="templates-list">
    <div *ngIf="isLoading" class="loading">
      Loading templates...
    </div>
    
    <div *ngIf="!isLoading && templates.length === 0" class="no-templates">
      No templates available
    </div>

    <div *ngIf="!isLoading && templates.length > 0" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 40%">Title</th>
            <th style="width: 15%">Organization Type</th>
            <th style="width: 15%"></th>
            <th style="width: 15%">Actions</th>
            <th style="width: 15%"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let template of templates">
            <td>{{ template.Title }}</td>
            <td>{{ announcementsService.convertOrgType(template.OrgType) }}</td>
            <td><a tabindex="0" class="pull-right" (click)="viewTemplate(template)" translate>View</a></td>
            <td><a tabindex="0" class="pull-right" (click)="editTemplate(template)" translate>Edit</a></td>
            <td><a class="trigger-modal delete pull-right" tabindex="0" aria-label="Delete template" 
              (click)="deleteTemplate(template)" (keypress)="deleteTemplate(template)">
              <img src="./assets/img/icons-svg/x-icon.svg">
            </a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div> 